import { Axios } from '@src/app/context/Api/includes/Axios';
import { translateCriteria } from '@src/entities/ActionPath/includes/functions';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isUndefined, omit, pick } from 'lodash';

/**
 * ListRiskRecords
 *
 * Retrieves a list of risk records from the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const ListRiskRecords = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = omit(payload?.[2], ['page', 'size', 'sort']);
    const thePagination = pick(payload?.[2], ['page', 'size', 'sort']);

    const requestArgs = {
      baseURL: config('API_URL'),
      data: {},
      headers: {
        'x-api-endpoint': '/risk-records/searchByCriteria',
      },
      method: 'POST',
      params: { ...{ apiKey: theApiKey, queryKey: theQueryKey }, ...thePagination },
    };

    delete thePayload?.criteria?.entrance?.mergedStr;
    delete thePayload?.criteria?.exit?.mergedStr;

    if (!isUndefined(thePayload?.criteria)) {
      requestArgs.data.criteria = translateCriteria(thePayload?.criteria, 'outgoing');
    }

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error('src/entities/RiskRecord/api/requests/queries/ListRiskRecords.js -> ListRiskRecords()', false, error);

    throw error;
  }
};
